import { Flex, Form, Switch } from "antd"
import { colors, spacings } from "themes/variables"
import { InfoTooltip } from "ui/Tooltip/InfoTooltip"
import { Text } from "ui/Typography"
import PropTypes from "prop-types"

export const AllowedTypesFormItem = ({ name, text, subText, infoText, hiddenSwitch, disabledSwitch, handleSwitchChange }) => {
  return (
    <Flex align="center" gap={spacings.XS}>
      {!hiddenSwitch && (
        <Form.Item name={name} valuePropName="checked" className="mb-0">
          <Switch size="small" disabled={disabledSwitch} onChange={(checked) => {
            handleSwitchChange?.(checked) }
            } />
        </Form.Item>
      )}
      <Text variant="body" size="md">
        {text}
      </Text>
      {subText && (
        <Text variant="body" size="md" color={colors.textSecondaryDark}>
          ({subText})
        </Text>
      )}
      {infoText && <InfoTooltip title={infoText} />}
    </Flex>
  )
}
AllowedTypesFormItem.propTypes = {
  name: PropTypes.string,
  text: PropTypes.string.isRequired,
  subText: PropTypes.string,
  infoText: PropTypes.string,
  hiddenSwitch: PropTypes.bool,
  disabledSwitch: PropTypes.bool,
  handleSwitchChange: PropTypes.func,
};